<template>
  <div class="container">
    <div style="width: 100%; font-size: 80px">
      <h1 class="title" style="display: flex; justify-content: space-between">
        <span>192015145</span> <span>stone</span>
      </h1>
    </div>
    <video  playsinline="true" src="/ganjalf.mp4" loop @load="$refs.video.play()" ref="video" autoplay ></video>
  </div>
</template>
<script>
export default {
  data() {
    return {
      links: [
      {
          
        },
        {
          image:
            "/mail.png",
          name : "stone@192015145.com",
          link: "mailto:stone@192015145.com",
        },
        {
         skip: true
        },
        {
          skip: true
        },

        {
          skip: true
        },
       
      ],
    };
  },
};
</script>

<style lang="scss">

.title {
  font-size: min(10vw, 15px);
  margin: 0px;
  font-weight: 100;
  text-decoration: none;
    color: white;
    cursor: pointer;
  span {
    text-decoration: none;
    color: white;
  }
}
video {
  object-fit: fill;
  width: 100%;
  height: calc(100% - 52px);
  border: none;
  position: fixed;
  z-index: 100;
  bottom: 0;
  left: 0;
  cursor: not-allowed;
}
.title {
  font-size: min(10vw, 15px);
  margin: 0px;
  font-weight: 100;
}
h1 {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 24px;
  font-style: normal;
  font-variant: normal;
  font-weight: 700;
  line-height: 26.4px;
}
h3 {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 14px;
  font-style: normal;
  font-variant: normal;
  font-weight: 700;
  line-height: 15.4px;
}
p,
a {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 14px;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  line-height: 20px;
}
blockquote {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 21px;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  line-height: 30px;
}
pre {
  font-family: TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia,
    serif;
  font-size: 13px;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  line-height: 18.5714px;
}
body {
  color: white;
  font-family: sans-serif;
  background-color: black;
}

.logo {
  width: 200px;
  margin-bottom: 20px;
}

.explain_grid {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(5, 1fr);
}
.container {
  height: 100dvh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  margin: auto;
}
</style>